import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Bars } from "react-loader-spinner";
import axiosInstance from "../../../Shared/axiosInstance.js";

export default function تحديث_المنتج() {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);

  const navigate = useNavigate();
  const { productId } = useParams();

  async function fetchCategories() {
    try {
      const { data } = await axiosInstance.get("/Category");
      setCategories(data?.data || []);
    } catch (error) {
      console.error("حدث خطأ أثناء جلب الأقسام:", error);
    }
  }

  async function fetchAllBrands() {
    try {
      const { data } = await axiosInstance.get("/Brand");
      setBrands(data?.data || []);
    } catch (error) {
      console.error("حدث خطأ أثناء جلب الماركات:", error);
    }
  }

  async function getProductById(id) {
    try {
      const { data } = await axiosInstance.get(`/Product/${id}`);
      return data?.data || null;
    } catch (error) {
      console.error("حدث خطأ أثناء جلب بيانات المنتج:", error);
      Swal.fire({
        title: "خطأ!",
        text: "فشل تحميل بيانات المنتج.",
        icon: "error",
      });
      navigate("/products");
      return null;
    }
  }

  const formik = useFormik({
    initialValues: {
      id: "",
      name: "",
      description: "",
      sellPrice: "",
      buyPrice: "",
      categoryId: "",
      brandId: "",
      barcode: "",
    },
    validate: (values) => {
      const errors = {};
      setErrorMsg(null);
      if (!values.name.trim()) errors.name = "اسم المنتج مطلوب";
      if (!values.sellPrice || values.sellPrice <= 0)
        errors.sellPrice = "سعر البيع يجب أن يكون أكبر من 0";
      if (!values.buyPrice || values.buyPrice <= 0)
        errors.buyPrice = "سعر الشراء يجب أن يكون أكبر من 0";
      if (!values.categoryId) errors.categoryId = "يرجى اختيار القسم";
      if (!values.brandId) errors.brandId = "يرجى اختيار الماركة";
      if (!values.barcode.trim()) errors.barcode = "الباركود مطلوب";
      return errors;
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const productData = {
          id: values.id,
          name: values.name,
          description: values.description,
          sellPrice: Number(values.sellPrice),
          buyPrice: Number(values.buyPrice),
          categoryId: values.categoryId,
          brandId: values.brandId,
          barcode: values.barcode,
        };

        const { data } = await axiosInstance.put(
          `/Product/${productId}`,
          productData
        );

        if (data?.status === 200) {
          await Swal.fire({
            title: "تم التحديث!",
            text: data.message || "تم تحديث المنتج بنجاح",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          navigate("/products");
        }
      } catch (error) {
        console.error("حدث خطأ أثناء تحديث المنتج:", error);
        setErrorMsg(
          error?.response?.data?.message || "حدث خطأ ما"
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    async function loadData() {
      setIsLoadingData(true);
      await Promise.all([fetchCategories(), fetchAllBrands()]);
      const productData = await getProductById(productId);
      if (productData) {
        formik.setValues({
          id: productData.id,
          name: productData.name || "",
          description: productData.description || "",
          sellPrice: productData.sellPrice || "",
          buyPrice: productData.buyPrice || "",
          categoryId: productData.categoryId || "",
          brandId: productData.brandId || "",
          barcode: productData.barcode || "",
        });
      }
      setIsLoadingData(false);
    }

    if (productId) loadData();
  }, [productId]);

  if (isLoadingData) {
    return (
      <div className="vh-100 d-flex flex-column align-items-center justify-content-center">
        <Bars height="80" width="80" color="#2563eb" ariaLabel="loading" />
        <p className="mt-3" style={{ color: "#64748b", fontSize: "18px" }}>
          جارٍ تحميل بيانات المنتج...
        </p>
      </div>
    );
  }

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", paddingBottom: "40px", direction: "rtl" }}>
      <div className="container py-5" style={{ maxWidth: "900px" }}>
        
        <div className="d-flex justify-content-between align-items-center mb-4 mt-5 pt-5">
          <div>
            <h2 style={{ color: "#2563eb", fontWeight: "700", fontSize: "28px", marginBottom: "4px" }}>
              <i className="bi bi-pencil-square me-2"></i>تحديث المنتج
            </h2>
            <small style={{ color: "#64748b", fontSize: "14px" }}>
              تعديل بيانات المنتج
            </small>
          </div>
          <button
            type="button"
            onClick={() => navigate("/products")}
            style={{
              background: "#64748b",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none",
              fontWeight: "600",
              fontSize: "15px",
              cursor: "pointer",
            }}
          >
            <i className="bi bi-arrow-left me-1"></i> رجوع
          </button>
        </div>

        {errorMsg && (
          <div
            style={{
              background: "#fee2e2",
              border: "1px solid #fecaca",
              color: "#991b1b",
              padding: "12px 16px",
              borderRadius: "8px",
              marginBottom: "20px",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            <i className="bi bi-exclamation-triangle me-2"></i>
            {errorMsg}
          </div>
        )}

        <div style={cardStyle}>
          <form onSubmit={formik.handleSubmit}>
            
            <div style={{ marginBottom: "30px" }}>
              <h5 style={sectionTitleStyle}>
                <i className="bi bi-info-circle me-2"></i>المعلومات الأساسية
              </h5>

              <div className="row g-3">
                <div className="col-md-6">
                  <label style={labelStyle}>اسم المنتج *</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="أدخل اسم المنتج"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      ...inputStyle,
                      borderColor: formik.touched.name && formik.errors.name ? "#dc2626" : "#cbd5e1",
                    }}
                  />
                  {formik.errors.name && formik.touched.name && (
                    <div style={errorStyle}>{formik.errors.name}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label style={labelStyle}>الباركود *</label>
                  <input
                    type="text"
                    name="barcode"
                    placeholder="أدخل الباركود"
                    value={formik.values.barcode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      ...inputStyle,
                      borderColor: formik.touched.barcode && formik.errors.barcode ? "#dc2626" : "#cbd5e1",
                    }}
                  />
                  {formik.errors.barcode && formik.touched.barcode && (
                    <div style={errorStyle}>{formik.errors.barcode}</div>
                  )}
                </div>

                <div className="col-12">
                  <label style={labelStyle}>الوصف</label>
                  <textarea
                    name="description"
                    placeholder="أدخل وصف المنتج (اختياري)"
                    rows="3"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    style={{
                      ...inputStyle,
                      resize: "vertical",
                      minHeight: "80px",
                    }}
                  />
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "30px" }}>
              <h5 style={sectionTitleStyle}>
                <i className="bi bi-tags me-2"></i>التصنيف
              </h5>

              <div className="row g-3">
                <div className="col-md-6">
                  <label style={labelStyle}>القسم *</label>
                  <select
                    name="categoryId"
                    value={formik.values.categoryId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      ...inputStyle,
                      borderColor: formik.touched.categoryId && formik.errors.categoryId ? "#dc2626" : "#cbd5e1",
                    }}
                  >
                    <option value="">-- اختر القسم --</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>{cat.name}</option>
                    ))}
                  </select>
                  {formik.errors.categoryId && formik.touched.categoryId && (
                    <div style={errorStyle}>{formik.errors.categoryId}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label style={labelStyle}>الماركة *</label>
                  <select
                    name="brandId"
                    value={formik.values.brandId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      ...inputStyle,
                      borderColor: formik.touched.brandId && formik.errors.brandId ? "#dc2626" : "#cbd5e1",
                    }}
                  >
                    <option value="">-- اختر الماركة --</option>
                    {brands.map((br) => (
                      <option key={br.id} value={br.id}>{br.name}</option>
                    ))}
                  </select>
                  {formik.errors.brandId && formik.touched.brandId && (
                    <div style={errorStyle}>{formik.errors.brandId}</div>
                  )}
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "30px" }}>
              <h5 style={sectionTitleStyle}>
                <i className="bi bi-currency-dollar me-2"></i>الأسعار
              </h5>

              <div className="row g-3">
                <div className="col-md-6">
                  <label style={labelStyle}>سعر الشراء *</label>
                  <input
                    type="number"
                    name="buyPrice"
                    placeholder="أدخل سعر الشراء"
                    step="0.01"
                    min="0"
                    value={formik.values.buyPrice}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onWheel={(e) => e.target.blur()}
                    style={{
                      ...inputStyle,
                      borderColor: formik.touched.buyPrice && formik.errors.buyPrice ? "#dc2626" : "#cbd5e1",
                    }}
                  />
                  {formik.errors.buyPrice && formik.touched.buyPrice && (
                    <div style={errorStyle}>{formik.errors.buyPrice}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label style={labelStyle}>سعر البيع *</label>
                  <input
                    type="number"
                    name="sellPrice"
                    placeholder="أدخل سعر البيع"
                    step="0.01"
                    min="0"
                    value={formik.values.sellPrice}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onWheel={(e) => e.target.blur()}
                    style={{
                      ...inputStyle,
                      borderColor: formik.touched.sellPrice && formik.errors.sellPrice ? "#dc2626" : "#cbd5e1",
                    }}
                  />
                  {formik.errors.sellPrice && formik.touched.sellPrice && (
                    <div style={errorStyle}>{formik.errors.sellPrice}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex gap-3">
              <button
                type="submit"
                disabled={!(formik.dirty && formik.isValid) || isLoading}
                style={{
                  flex: 1,
                  background:
                    formik.dirty && formik.isValid && !isLoading
                      ? "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)"
                      : "#94a3b8",
                  color: "#fff",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "none",
                  fontWeight: "700",
                  fontSize: "18px",
                  cursor:
                    formik.dirty && formik.isValid && !isLoading
                      ? "pointer"
                      : "not-allowed",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {isLoading ? (
                  <>
                    <Bars height="25" width="25" color="#fff" ariaLabel="loading" />
                    <span>جارٍ التحديث...</span>
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-circle"></i>
                    <span>تحديث المنتج</span>
                  </>
                )}
              </button>

              <button
                type="button"
                onClick={() => navigate("/products")}
                style={{
                  flex: 1,
                  background: "#fff",
                  color: "#475569",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "2px solid #cbd5e1",
                  fontWeight: "700",
                  fontSize: "18px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <i className="bi bi-x-circle"></i>
                <span>إلغاء</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// ✅ Styles
const cardStyle = {
  background: "#fff",
  border: "1px solid #e2e8f0",
  borderRadius: "12px",
  padding: "32px",
  marginBottom: "20px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
};

const sectionTitleStyle = {
  color: "#1e293b",
  fontSize: "16px",
  fontWeight: "700",
  marginBottom: "16px",
  paddingBottom: "8px",
  borderBottom: "2px solid #e2e8f0",
};

const labelStyle = {
  color: "#475569",
  fontSize: "14px",
  fontWeight: "600",
  marginBottom: "8px",
  display: "block",
};

const inputStyle = {
  width: "100%",
  padding: "12px 16px",
  border: "2px solid #cbd5e1",
  borderRadius: "8px",
  fontSize: "15px",
  color: "#1e293b",
  outline: "none",
  transition: "all 0.2s",
  fontWeight: "500",
};

const errorStyle = {
  color: "#dc2626",
  fontSize: "13px",
  marginTop: "6px",
  fontWeight: "600",
};
